import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "as-back-green" }
const _hoisted_2 = { class: "as-team-info as-team-info-home" }
const _hoisted_3 = {
  key: 0,
  class: "as-team-name"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "as-home-name" }
const _hoisted_6 = {
  key: 0,
  class: "as-formation as-formation-home"
}
const _hoisted_7 = {
  key: 1,
  class: "as-coach-name"
}
const _hoisted_8 = { class: "as-ground-box" }
const _hoisted_9 = { class: "as-lineup-players" }
const _hoisted_10 = { class: "as-team-info as-team-info-away" }
const _hoisted_11 = {
  key: 0,
  class: "as-team-name"
}
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "as-home-name" }
const _hoisted_14 = {
  key: 0,
  class: "as-formation as-formation-away"
}
const _hoisted_15 = {
  key: 1,
  class: "as-coach-name"
}
const _hoisted_16 = { class: "as-note" }

import { computed } from "vue";
import type {
  ILineups,
  IMatch,
  IPlayer,
  IIncidentStatistic,
} from "~src/interfaces";
import SquadItem from "~src/components/lineups/SquadItem.vue";
import MatchEnum from "~src/enums/MatchEnum";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  lineups: ILineups;
  match: IMatch;
  startingPlayers: Object;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SquadTab',
  props: {
    lineups: {},
    match: {},
    startingPlayers: {}
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;
const siteName = computed(() => commonStore.getSiteName);

const listIncidents: IIncidentStatistic[] = MatchEnum.INCIDENT_LIST;

const lineupsHomeAway = computed(() => {
  const filterByStatus = (team: IPlayer[]) => {
    return team && Array.isArray(team)
      ? team.filter((player) => player.first === 1)
      : [];
  };
  let home: IPlayer[] = [],
    away: IPlayer[] = [];

  if (props.lineups.id) {
    try {
      home = filterByStatus(props.lineups.lineup.home);
      away = filterByStatus(props.lineups.lineup.away);
    } catch (error) {
      console.error("Error filtering lineups:", error);
    }
  }

  return {
    home,
    away,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-line-ups", `as-line-ups-${siteName.value}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.match && _ctx.match.home_team)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _ctx.getImgUrlBySport('team', _ctx.match?.home_team?.id),
                class: "as-match__team-logo",
                alt: _ctx.match?.home_team?.name
              }, null, 8, _hoisted_4),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.match?.home_team?.short_name_vi || _ctx.match?.home_team?.name), 1),
              (_ctx.lineups.home_formation)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(_ctx.lineups.home_formation) + ") ", 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.lineups && _ctx.lineups.coach && _ctx.lineups.coach.home)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " HLV: " + _toDisplayString(_ctx.lineups.coach.home.name), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "as-mid-circle" }, [
          _createElementVNode("div", { class: "as-mid-inner" })
        ], -1)),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['home', 'away'], (team, key) => {
          return _createElementVNode("div", {
            key: key,
            class: _normalizeClass(["as-w-100 as-half-box", {
            'as-half-box-away': team === 'away',
          }])
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "as-square2" }, [
              _createElementVNode("div", { class: "as-square1" })
            ], -1)),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-w-100" }, [
              _createElementVNode("div", { class: "as-circle" })
            ], -1)),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(SquadItem, {
                players: 
                team === 'home' ? lineupsHomeAway.value.home : lineupsHomeAway.value.away
              ,
                screen: "sm",
                isSmAll: true,
                teamType: team
              }, null, 8, ["players", "teamType"])
            ])
          ], 2)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.match && _ctx.match.home_team)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("img", {
                src: _ctx.getImgUrlBySport('team', _ctx.match?.away_team?.id),
                class: "as-match__team-logo",
                alt: _ctx.match?.away_team?.name
              }, null, 8, _hoisted_12),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.match?.away_team?.short_name_vi || _ctx.match?.away_team?.name), 1),
              (_ctx.lineups.away_formation)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, " (" + _toDisplayString(_ctx.lineups.away_formation) + ") ", 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.lineups && _ctx.lineups.coach && _ctx.lineups.coach.away)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, " HLV: " + _toDisplayString(_ctx.lineups.coach.away.name), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listIncidents), (incident, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "as-note-item"
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(incident.icon))),
          _createTextVNode(_toDisplayString(incident.label), 1)
        ]))
      }), 128))
    ])
  ], 2))
}
}

})